import React from "react";

// images
import logo from "../images/logo_comarb.png";
import sircreb from "../images/sircreb.png";
import sircupa from "../images/sircupa.png";
import sirtac from "../images/sirtac.png";
import linea from "../images/linea-divisoria.png";

import "../styles/header.css";

function Cabecera() {
  return (
    <div className="header_top">
      <div>
        <div className="col-lg-12 ps-4">
          <img src={logo} alt="" className="logo mr-1px" />
          <img src={linea}  className="linea ml-1" alt="" />
          <img src={sircreb} className="logo-sis" alt=""/>
          <img src={linea}  className="linea" alt="" />
          <img src={sircupa} className="logo-sis" alt="" />  
          <img src={linea}  className="linea" alt="" />
          <img src={sirtac} className="logo-sirtac" alt="" />
        </div>
      </div>
    </div>
  );
}

export default Cabecera;
